import { CacheStrategy } from '@rammetec/data-access';
import { AUDIT_FIELD_DESCRIPTORS, AUDIT_FOREIGN_KEYS } from './_auditFields.js';
import { LIFECYCLE_FIELD_DESCRIPTORS } from './_lifecycleFields.js';
import { BUSINESS_ALLOWED_DATA_SOURCES, BUSINESS_DEFAULT_DATA_SOURCE } from './dataSourcePolicy.js';
import { PROCESS } from '../types/process.js';
import { FIELD_LIMITS } from '../validation/fieldLimits.js';
/**
 * Descriptor for Process entity.
 * Stored in 'org/{orgId}/process'.
 */
export const processDescriptor = {
    name: PROCESS,
    label: 'Processo',
    domain: 'catalog',
    collectionPath: 'org/{orgId}/process',
    pathPatternKeys: {
        orgId: 'string',
    },
    version: 1,
    description: 'Production step that can be associated with the technical sheet',
    repositoryConfig: {
        dataSource: BUSINESS_DEFAULT_DATA_SOURCE,
        cache: CacheStrategy.InMemory,
    },
    allowedDataSources: BUSINESS_ALLOWED_DATA_SOURCES,
    fields: [
        {
            name: 'id',
            label: 'ID',
            type: 'string',
            required: true,
            description: 'Unique process identifier',
        },
        {
            name: 'code',
            example: 20,
            label: 'Código',
            type: 'number',
            display: 'code',
            required: true,
            unique: true,
            autoNumber: true,
            description: 'Numeric process code (master-data identifier; non-negative, capped at MAX_CODE_SMALL)',
        },
        {
            name: 'description',
            example: 'Tingimento em jet',
            label: 'Descrição',
            type: 'string',
            required: true,
            maxLength: FIELD_LIMITS.NAME,
            description: 'Process description',
        },
        {
            name: 'sectorId',
            label: 'Setor',
            type: 'string',
            required: true,
            description: 'Reference to the sector',
        },
        {
            name: 'operationId',
            label: 'Operação',
            type: 'string',
            required: true,
            description: 'Reference to the operation',
        },
        {
            name: 'productionInstructions',
            example: 'Tempo padrão 45 min — validar solidez da cor',
            label: 'Instruções de produção',
            type: 'string',
            required: false,
            description: 'Production instructions for the process',
        },
        ...LIFECYCLE_FIELD_DESCRIPTORS,
        ...AUDIT_FIELD_DESCRIPTORS,
    ],
    foreignKeys: [
        ...AUDIT_FOREIGN_KEYS,
        {
            fieldName: 'sectorId',
            targetEntity: 'Sector',
            relationship: 'many-to-one',
            description: 'The sector for this process',
            displayField: 'description',
        },
        {
            fieldName: 'operationId',
            targetEntity: 'Operation',
            relationship: 'many-to-one',
            description: 'The operation for this process',
            displayField: 'description',
        },
    ],
};
//# sourceMappingURL=process.descriptor.js.map